<template>
  <div class="text-align-center">
    <img :src="vehicleIcon" :alt="vehicleAltText" width="80" />
  </div>
</template>

<script>
export default {
  name: 'VehicleIcon',
  props: {
    vehicleType: {
      type: Number,
      required: true,
    },
    quotationType: {
      type: String,
      required: true,
    },
  },
  computed: {
    vehicleIcon() {
      if (this.vehicleType) {
        return '../../../images/project-img/ico-bike-blue.png';
      } else {
        return '';
      }
    },
    vehicleAltText() {
      if (this.vehicleType) {
        return 'Bike icon';
      }
    },
  },
};
</script>



// WEBPACK FOOTER //
// resources/js/app/components/VehicleIcon.vue